import { cn } from "@/lib/utils";

interface ScoreBarProps {
  score: number | null;
  isWinner?: boolean;
  showLabel?: boolean;
  label?: string;
  size?: "sm" | "default";
}

export function ScoreBar({ score, isWinner = false, showLabel = true, label, size = "default" }: ScoreBarProps) {
  const height = size === "sm" ? "h-1" : "h-[5px]";
  const hasScore = typeof score === "number";
  const clampedScore = hasScore ? Math.min(100, Math.max(0, score)) : 0;

  return (
    <div className="flex items-center gap-3">
      {label && (
        <span className="text-[13px] text-slate-600 min-w-[100px] truncate">
          {label}
        </span>
      )}
      <div className={cn("flex-1 bg-slate-100 rounded-full overflow-hidden", height)}>
        <div
          className={cn(
            "rounded-full animate-score-fill",
            height,
            isWinner ? "bg-accent-500" : "bg-brand-600"
          )}
          style={{ width: `${clampedScore}%` }}
        />
      </div>
      {showLabel && (
        <span className={cn(
          "text-[13px] font-semibold w-8 text-right tabular-nums",
          isWinner ? "text-accent-700" : "text-brand-950"
        )}>
          {hasScore ? score : "N/A"}
        </span>
      )}
    </div>
  );
}
